import styled from "@emotion/styled";

export const OrganizationContentWrapper = styled.div`
	flex-grow: 1;
	padding: 70px 70px 70px 55px;
	position: relative;
`;

export const OrganizationContentTitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	align-items: center;
`;

export const OrganizationContentTitle = styled.p`
	font-size: 20px;
	line-height: 28px;
	color: #121212;
	font-weight: 700;
`;
